import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {toast} from 'react-toastify';
import axios from '../../../../../axios-instance';
import { getHeaders } from "../../../../../helpers/getHeaders";
import ROUTES from "../../../../../constants/routes";
import { getCustomURLs } from "../../../../../helpers/getCustomURLs";
import NewLoader from "../../../../../components/NewLoader/NewLoader";

import "../Iframes.sass";
import sr from 'date-fns/locale/sr-Latn';
import fr from 'date-fns/locale/fr';
import 'moment/locale/fr';
import 'moment/locale/sr';
import { getRegion } from "../../../../../helpers/getRegion";
import { getCurrentLanguageTexts, setLangCode } from "../../../../../constants/seasonPassPersonalInfoLangs";

const IframePreview = ({ localIframeData, token, ...props }) => {
  const [iframe, setIframe] = useState({ events: [] });
  const [hoverId, setHoverId] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isDatesChange, setDatesChange] = useState(false);
  let locale = "en";

  const { theme } = getRegion();

  switch (theme) {
    case 'france':
      registerLocale('fr', fr);
      moment.locale('fr');
      setLangCode('en');
      locale = "fr";
      break;

    case 'sixtix':
    case 'fanceetickets':
      registerLocale('sr', sr);
      moment.locale('sr');
      setLangCode('rs');
      locale = "sr";
      break;

    default:
      break;
  }

  const { generalTxt } = getCurrentLanguageTexts();

  const handleMouseEnter = (id) => {
    setHoverId(id);
  };
  const handleMouseLeave = () => {
    setHoverId(null);
  };

  const getData = async () => {
    setLoading(true);
    try {
      const slug = props.match.params.slug;
      const { data } = await axios.get(`/iFrame/${slug}`, {headers: getHeaders(token)});

      setIframe(data)

    } catch (error) {
      toast.error("Iframe not received");
    } finally {
      setLoading(false)
    }
  };

  const goToEventPage = (slug) => {
    const { PUBLIC_URL } = getCustomURLs();
    window.open(
      PUBLIC_URL + ROUTES.SELLING.replace(':slug', slug).replace('/:id?', ''),
      '_blank'
    );
  }

  useEffect(() => {
    if (props.match.path === ROUTES.IFRAME) {
      getData();

      const bodyList = document.getElementsByTagName('body');

      for (const body of bodyList) {
        body.style.background = 'transparent';
      }
    } else {
      setIframe(localIframeData);
    };
  }, [localIframeData]);

  useEffect(() => {
    const calendar = document.getElementsByClassName('custom-calendar')[0];

    if (iframe.listVersion === 1 && iframe.events.length !== 0 && calendar) {
      const calendarHeader = calendar.getElementsByClassName('react-datepicker__header')[0];
      
      const calendarMonth = calendar.getElementsByClassName('react-datepicker__month-container')[0];
      const eventDays = calendar.getElementsByClassName('react-datepicker__day');
      const calendarToday = calendar.getElementsByClassName('react-datepicker__day--today')[0];
      const navPrev = calendar.getElementsByClassName('react-datepicker__navigation--previous')[0];
      const navNext = calendar.getElementsByClassName('react-datepicker__navigation--next')[0];

      for (const day of eventDays) {
        if (day.classList.contains('iframe__event-day')) {
          day.style.backgroundColor = iframe.primaryColor;
          day.style.color = iframe.secondaryTextColor;

          day.addEventListener("mouseenter", (e) => {
            e.currentTarget.style.backgroundColor = iframe.hoverColor;
          });
          day.addEventListener("mouseleave", (e) => {
            e.currentTarget.style.backgroundColor = iframe.primaryColor;
          });
        } else {
          day.style.backgroundColor = iframe.backgroundColor;
          day.style.color = iframe.primaryTextColor;

          day.addEventListener("mouseenter", (e) => {
            e.currentTarget.style.backgroundColor = iframe.backgroundColor;
          });
          day.addEventListener("mouseleave", (e) => {
            e.currentTarget.style.backgroundColor = iframe.backgroundColor;
          });
        }
      }

      calendar.style.border = `1px solid ${iframe.primaryColor}`;
      calendarHeader.style.backgroundColor = iframe.primaryColor;
      calendarHeader.style.color = iframe.secondaryTextColor;
      calendarMonth.style.backgroundColor = iframe.backgroundColor;
      navPrev.style.borderRightColor = iframe.secondaryTextColor;
      navNext.style.borderLeftColor = iframe.secondaryTextColor;

      if (!!calendarToday) {
        calendarToday.style.border = `1px solid ${iframe.primaryColor}`;
        calendarToday.style.borderRadius = "0.3rem";
      }
    }

    setDatesChange(false);
  }, [iframe, isDatesChange, isLoading]);

  if (isLoading) {
    return <NewLoader />
  };

  if (iframe.listVersion === 0) {
    return (
      <div
        className="large-list"
        style={{
          fontFamily: `${iframe.fontFamily}`,
          backgroundColor: iframe.backgroundColor,
          color: iframe.primaryTextColor,
        }}
      >
        <div className="large-list__title">
          {generalTxt.upcomingEvents}
        </div>

        <div className="large-list__event-container">
          {iframe.events.map((currEvent) => (
            <div
              key={currEvent.id}
              className="large-list__event"
              style={{
                backgroundColor: hoverId === currEvent.id || hoverId === currEvent.slug ? `${iframe.hoverColor}` : `inherit`,
                cursor: 'pointer'
              }}
              onMouseEnter={() => handleMouseEnter(currEvent.id || currEvent.slug)}
              onMouseLeave={handleMouseLeave}
              onClick={() => goToEventPage(currEvent.slug)}
            >
              <div
                className="large-list__event-date-wrapper"
                style={{
                  borderColor: iframe.primaryColor,
                  backgroundColor: iframe.dayColor,
                }}
              >
                <div
                  className="large-list__event-month"
                  style={{
                    backgroundColor: iframe.primaryColor,
                    color: iframe.secondaryTextColor,
                  }}
                >
                  {moment(currEvent.startDate).format("MMMM")}
                </div>
                <div className="large-list__event-date">
                  {moment(currEvent.startDate).format("DD")}
                </div>
                <div className="large-list__event-day">
                  {moment(currEvent.startDate).format("dddd")}
                </div>
              </div>
              <div className="large-list__event-info">
                <div className="large-list__event-name">
                  {currEvent.name}
                </div>

                <div className="large-list__event-full-date">
                  {moment(currEvent.startDate).format("DD.MM.YYYY HH:mm")}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  };

  if (iframe.listVersion === 1) {
    return (
      <div
        style={{
          fontFamily: `${iframe.fontFamily}`,
          color: `${iframe.primaryTextColor}`,
        }}
        className="iframe__agenda-wrapper"
      >
        <DatePicker
          onChange={(date) => {
            const currDay = moment(date).utc().startOf("D").format();
            
            const event = iframe.events.find(eventInfo => {
              return moment(eventInfo.startDate).utc().startOf("D").format() === currDay;
            });

            if (event) {
              goToEventPage(event.slug)
            };
          }}
          dayClassName={(date) => {
            const currDay = moment(date).utc().startOf("D").format();
            
            const isDate = iframe.events.some(eventInfo => {
              return moment(eventInfo.startDate).utc().startOf("D").format() === currDay;
            })
            return isDate ? "iframe__event-day" : undefined
          }}
          onMonthChange={() => {
            setDatesChange(true);
          }}
          inline
          calendarClassName="custom-calendar"
          locale={locale}
        />
      </div>
    )
  };

  return null
};

const mapStateToProps = ({ auth, promoter }) => ({
  token: auth.user.token,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(IframePreview)
);
